export default __webpack_public_path__ + "static/media/gallery_03.9e1b312a.jpg";